export enum PetMicrochipField {
  chipNo = 'microchipNumber',
  hasMicrochip = 'hasMicrochip',
}
